import { useState, useEffect, useMemo, useContext, useRef } from 'react';
import { ToastContext } from '../../../context/ToastContext';
import { Urls } from '../../../services/Urls';
import services from '../../../services/services';
import { useNavigate } from 'react-router-dom';
import _ from 'underscore';
import { callautopopulate } from '../../../services/callautopop';
import { getFullMonthSelected } from '../../../utils/Helper';



export const usePrecisionPulseReport = () => {
    const { showInfo, showSuccess, showError } = useContext(ToastContext)
    const [data, setData] = useState([]);
    const [previousData, setPreviousData] = useState([])
    const [monthYear, setMonthYear] = useState(new Date());
    const [loader, setLoader] = useState(false);
    const [missingFields, setMissingFields] = useState({});
    const navigate = useNavigate();
    const [userCode, setUserCode] = useState(null);
    const [spin, setSpin] = useState(false);
    const tagRef = useRef();
    const isChangeRef = useRef(false);
    const [involvementLevels, setInvolvementLevels] = useState([]);

    useEffect(() => {
        callautopopulate("user_info", "user_involvement_levels").then((res) => {
            setUserCode(res?.user_info[0]?.user_code)
            setInvolvementLevels(res?.user_involvement_levels)

        })
        getprecisionPulsMetric();
    }, [monthYear]);

    const getprecisionPulsMetric = async () => {
        try {
            setLoader(true)
            const payload = {
                "month": new Date(monthYear).getMonth() + 1,
                "year": new Date(monthYear).getFullYear(),
            }
            const res = await services?.getInvokeRemote("POST", Urls("GETTEAMOVERVIEWPRECISIONPULSEMETRICS"), payload);
            if (!res?.body?.data?.error_status && res?.body?.data?.team_precision_pulse_metrics_list.length > 0) {
                setData(res?.body?.data?.team_precision_pulse_metrics_list);
                setPreviousData(res?.body?.data?.team_precision_pulse_metrics_list)
                setMissingFields({})
            }
            setLoader(false)
        } catch (error) {
            console.error("error", error);
            setLoader(false)
        }
    }

    const handleSubmit = async () => {
        try {
            if (!monthYear) {
                alert("Please select a month and year.");
                return;
            }
            let fieldsWithIssues = {};
            let hasErrors = false;
            data.forEach(row => {
                const requiredFields = [
                    'bu_rank', 'db_eff_rank', 'tech_rank', 'time_efficiency_rank',
                    'overall_standing_rank', 'involvement_level_name',
                    'strength', 'weakness', 'opportunity', 'threat'
                ];
                requiredFields.forEach(field => {
                    if (
                        row[field] === null ||
                        row[field] === undefined ||
                        (typeof row[field] === 'string' && row[field].trim() === '')
                    ) {
                        hasErrors = true;
                        if (!fieldsWithIssues[row.user_code]) {
                            fieldsWithIssues[row.user_code] = [];
                        }
                        fieldsWithIssues[row.user_code].push(field);
                    }
                });
            });

            setMissingFields(fieldsWithIssues);
            if (hasErrors) {
                showInfo("warn", "Please fill all required fields.");
                return;
            }
            setSpin(true)
            const payload = {
                "from_date": getFullMonthSelected(monthYear)?.from_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                "to_date": getFullMonthSelected(monthYear)?.to_date?.toLocaleDateString("en-GB").split("/").reverse().join("-") || "",
                "is_submit": true,
                "approver_user_code": userCode,
                "users": _.uniq(_.pluck(data, "user_code")).toString()
            }
            const res = await services?.getInvokeRemote("POST", Urls("TEAMOVERVIEWPRECISIONPULSEMETRICSSUBMIT"), payload)
            if (!res?.body?.success) {
                showSuccess("success", res?.body?.message)
            } else {
                showError("Error", res.body.errorMessage);
            }
            setSpin(false)
        } catch (error) {
            setSpin(false)
            console.error("error", error);
        }
    };


    // upsert API calling after every cell update
    const upsertPulsMetrics = async (row) => {
        const isEqualData = previousData?.find(item => item.user_code === row.user_code);
        const cleanRow = { ...row };
        delete cleanRow.__missingKey;
        const cleanIsEqualData = { ...isEqualData };
        delete cleanIsEqualData.__missingKey;
        if (!_.isEqual(isEqualData, cleanRow)) {
            try {
                const payload = {
                    month: new Date(monthYear).getMonth() + 1,
                    year: new Date(monthYear).getFullYear(),
                    Requested_user_code: row.user_code || 0,
                    bu_rank: row.bu_rank || 0,
                    db_eff_rank: row.db_eff_rank || 0,
                    tech_rank: row.tech_rank || 0,
                    time_efficiency_rank: row.time_efficiency_rank || 0,
                    overall_standing_rank: row.overall_standing_rank || 0,
                    involvement_level_id: involvementLevels.find(lvl => lvl.involvement_level_name === row.involvement_level_name)?.involvement_level_id || 0,
                    strength: row.strength || "",
                    weakness: row.weakness || "",
                    opportunity: row.opportunity || "",
                    threat: row.threat || "",
                };
                const res = await services.getInvokeRemote("POST", Urls("UPSERTTEAMOVERVIEWPRECISIONPULSEMETRICS"), payload);
                if (!res?.body?.error_status) {
                    const updated = data.map(item =>
                        item.user_code === row.user_code ? row : item
                    );
                    setPreviousData(updated);
                    showSuccess("success", res?.body?.message)
                }
            } catch (error) {
                console.error("upsert error", error);
            }
        }
    };

    useEffect(() => {
        if (!data || !Array.isArray(data)) return;
        setData(prevData =>
            prevData.map(row => ({
                ...row,
                __missingKey: (missingFields[row.user_code] || []).join(',')
            }))
        );
        // eslint-disable-next-line
    }, [missingFields]);

    const renderInputNumber = (rowData, field) => {
        const missing = missingFields[rowData.user_code]?.includes(field);
        return (
            <input
                key={rowData.__missingKey + field}
                className={`${missing ? "precision-highlight" : ""}`}
                type="text"
                value={rowData[field]}
                onChange={e => {
                    let cleaned = e.target.value.replace(/[^0-9]/g, '');
                    if (cleaned === '0' || cleaned.startsWith('0')) {
                        showInfo("warn", "Value cannot be 0 or start with 0")
                    }
                    cleaned = cleaned.startsWith("0") ? "" : cleaned;
                    updateCell(rowData.user_code, field, cleaned);
                }}
                onBlur={() => {
                    if (isChangeRef.current) {
                        rowData[field] && upsertPulsMetrics(data.find(item => item.user_code === rowData.user_code));
                        isChangeRef.current = false;
                    }
                }}
                style={{ width: '5rem' }}
            />
        );
    };

    const renderDropdown = (rowData) => {
        const missing = missingFields[rowData.user_code]?.includes('involvement_level_name');
        return (
            <select
                key={rowData.__missingKey + "_dropdown"}
                className={`${missing ? "precision-highlight" : ""}`}
                value={rowData.involvement_level_name}
                onChange={(e) => { updateCell(rowData.user_code, 'involvement_level_name', e.target.value); }}
                style={{ width: '10rem' }}
                onBlur={() => {
                    if (isChangeRef.current) {
                        upsertPulsMetrics(data.find(item => item.user_code === rowData.user_code))
                        isChangeRef.current = false;
                    }
                }}
            >
                <option value="">Select</option>
                {involvementLevels.map(opt => (
                    <option key={opt.involvement_level_id} value={opt.involvement_level_name}>{opt.involvement_level_name}</option>
                ))}
            </select>
        );
    };
    const renderTextarea = (rowData, field) => {
        const missing = missingFields[rowData.user_code]?.includes(field);
        return (
            <textarea
                key={rowData.__missingKey + field}
                value={rowData[field]}
                onChange={(e) => { updateCell(rowData.user_code, field, e.target.value); }}
                rows={1}
                style={{ width: '100%' }}
                className={`${missing ? "precision-highlight" : ""}`}
                onBlur={() => {
                    if (isChangeRef.current) {
                        upsertPulsMetrics(data.find(item => item.user_code === rowData.user_code))
                        isChangeRef.current = false;
                    }
                }}
            />
        );
    };

    const updateCell = (user_code, field, value) => {
        isChangeRef.current = true;
        setData(prevData =>
            prevData.map(item =>
                item.user_code === user_code ? { ...item, [field]: value } : item
            )
        );
        setMissingFields(prev => {
            if (!prev[user_code]?.includes(field)) return prev;
            const newFields = { ...prev };
            newFields[user_code] = newFields[user_code].filter(f => f !== field);
            if (newFields[user_code].length === 0) {
                delete newFields[user_code];
            }
            return newFields;
        });
    };



    const changeMonth = (increment) => {
        let newMonth = new Date(monthYear);
        newMonth.setMonth(newMonth.getMonth() + increment);
        setMonthYear(newMonth);
    };

    return useMemo(() => ({
        monthYear, setMonthYear, data, renderDropdown, renderInputNumber, renderTextarea, changeMonth, handleSubmit, loader, navigate, spin, tagRef
    }), [monthYear, setMonthYear, data, renderDropdown, renderInputNumber, renderTextarea, changeMonth, handleSubmit, loader, navigate, spin, tagRef]);
}
